import { AppliedFilters } from "./AppliedFilters";
import { DynamicFilters } from "./DynamicFilters";

export { DynamicFilters } from "./DynamicFilters";

export const DynamicFilter = {
    Toolbar: DynamicFilters,
    AppliedFilters
}